import { lazy } from "react";
import Loadable from "components/Loadable";
import * as url2 from "../Sampling-Plan/utils/urlHelper";
import { getStatusTypes } from "./service";
import {
  FormatConstants,
  routeConstants,
} from "services/keyConstants";
import { showToast } from "services/utils";
import { ApiServices } from "services/apiServices";
import { getMasterDocDataByKey } from "services/ReduxUtils";
import { mamOfProductDownload, mamOfProductList } from "api/module/mamOfProduct";
import { createAuditLog } from "services/auditTrail";

// Lazy-loaded components

// Product Related
const RawMaterialDescription = Loadable(
  lazy(() => import("pages/NewPurchase/RawMaterialDescription"))
);
const PackagingMaterialDescription = Loadable(
  lazy(() => import("pages/NewPurchase/PackagingMaterialDescription"))
);
const AccessoriesDescription = Loadable(
  lazy(() => import("pages/NewPurchase/AccessoriesDescription"))
);
// Product Plan
const ProductPlan = Loadable(
  lazy(() => import("../Product-Plan/ProductPlan"))
);
// Sampling Plan
const SamplingManage = Loadable(lazy(() => import("../Sampling-Plan/Manage")));
// Inprocess Form
const InProcessPlanForm = Loadable(
  lazy(() => import("../InProcessInspection/InProcessPlanForm"))
);
// Final Form
const FinalInspectionForm = Loadable(
  lazy(() => import("../Final-Inspection/FinalInspectionForm"))
);
const PlanForSterilityAssessment = Loadable(
  lazy(() => import("../PlanForSterilityAssessment"))
);
const BiologicalIndicatorTestReport = Loadable(
  lazy(() => import("../BiologicalIndicatorTestReport"))
);
const ChemicalIndicatorTestReport = Loadable(
  lazy(() => import("../ChemicalIndicatorTestReport"))
);
const SterilityTestReport = Loadable(
  lazy(() => import("../SterilityTestReport"))
);

const AddPlan = Loadable(lazy(() => import("../Product-Plan/AddPlan")));
const CommonDetail = Loadable(
  lazy(() => import("components/CommonDetail/CommonDetail"))
);


const handleCreateSamplingPlan = async () => {
  try {
    let result;
    const reqObj = {
      documentName: FormatConstants.MAMOFPRODUCT.SAMPLING_PLAN,
    };

    const masterDocData = getMasterDocDataByKey({
      defaultName: FormatConstants.MAMOFPRODUCT.SAMPLING_PLAN,
    });

    reqObj.auditObj = createAuditLog({
      data: { masterDocId: masterDocData?.masterDocId },
      locationPath: `../../${routeConstants?.MAM_OF_PRODUCT}/detail/${masterDocData?.masterDocId}`,
    });

    reqObj.masterDocId = masterDocData?.masterDocId;
    result = await ApiServices.callServicePostWithBodyData(url2?.ADD, reqObj);

    showToast(result);
    if (result?.meta?.success) {
      window.dispatchEvent(new CustomEvent("refreshData", {}));
    }
  } catch (error) {
    console.error(error);
  }
};

const MAMRoutes = [
  {
    path: routeConstants.MAM_OF_PRODUCT,
    children: [
      // Product Related
      {
        path: "raw-material-description/:id?",
        element: <RawMaterialDescription />,
      },
      {
        path: "packaging-material-description/:id?",
        element: <PackagingMaterialDescription />,
      },
      {
        path: "accessories-description/:id?",
        element: <AccessoriesDescription />,
      },
      // Common Detail with navigate, buttons, filters
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item, filterData, masterDocData) => {
                const basePath = `/${routeConstants.MAM_OF_PRODUCT}`;
                const basePathForCommon = `${basePath}/${item?._id}`;
                if (
                  masterDocData?.defaultName ===
                  FormatConstants.MAMOFPRODUCT.INPROCESS_INSPECTION_REPORT
                ) {
                  return `${basePath}/inprocess-form/${item?._id}`;
                } else if (
                  masterDocData?.defaultName ===
                  FormatConstants.MAMOFPRODUCT.FINAL_INSPECTION_REPORT
                ) {
                  return `${basePath}/final-process-form/${item?._id}`;
                } else if (
                  [
                    FormatConstants.MAMOFPRODUCT.FINAL_INSPECTION_PLAN,
                    FormatConstants.MAMOFPRODUCT.INPROCESS_INSPECTION_PLAN,
                    FormatConstants.MAMOFPRODUCT.PLAN_FOR_STERILITY_ASSESSMENT,
                  ].includes(masterDocData?.defaultName)
                ) {
                  return `${basePath}/product-plan/${item?.productId}`;
                } else if (
                  [FormatConstants.MAMOFPRODUCT.SAMPLING_PLAN].includes(
                    masterDocData?.defaultName
                  )
                ) {
                  return `${basePath}/sampling-plan/manage/${item?._id}`;
                } else if (
                  [
                    FormatConstants.MAMOFPRODUCT.STERILITY_TESTING_REPORT,
                  ].includes(masterDocData?.defaultName)
                ) {
                  return `${basePath}/sterility-test-report/${item?._id}`;
                }else if (
                  [
                    FormatConstants.MAMOFPRODUCT.BIOLOGICAL_INDICATOR_TEST_REPORT,
                  ].includes(masterDocData?.defaultName)
                ) {
                  return `${basePath}/biological-indicator-test-report/${item?._id}`;
                }else if (
                  [
                    FormatConstants.MAMOFPRODUCT.CHEMICAL_INDICATOR_TEST_REPORT,
                  ].includes(masterDocData?.defaultName)
                ) {
                  return `${basePath}/chemical-indicator-test-report/${item?._id}`;
                }
                return basePathForCommon;
              },
            }}
            url={{ GET: mamOfProductList, DOWNLOAD: mamOfProductDownload }}
            getStatusTypes={getStatusTypes}
            filterOptions={{
              [FormatConstants.MAMOFPRODUCT.INPROCESS_INSPECTION_REPORT]: [
                {
                  name: "Status",
                  optionsKey: "statusOptions",
                  isHiddenAll: true,
                },
              ],
              [FormatConstants.MAMOFPRODUCT.FINAL_INSPECTION_REPORT]: [
                {
                  name: "Status",
                  optionsKey: "statusOptions",
                  isHiddenAll: true,
                },
              ],
            }}
            buttonsData={(masterDocData) => {
              if (
                masterDocData?.defaultName ===
                FormatConstants.MAMOFPRODUCT.SAMPLING_PLAN
              ) {
                return [
                  {
                    name: "Add",
                    onClick: (item) => {
                      handleCreateSamplingPlan();
                    },
                    disabled: (data) => {
                      return data?.rows?.length > 0;
                    },
                  },
                ];
              }
              if (
                [
                  FormatConstants.MAMOFPRODUCT.FINAL_INSPECTION_PLAN,
                  FormatConstants.MAMOFPRODUCT.INPROCESS_INSPECTION_PLAN,
                ].includes(masterDocData?.defaultName)
              ) {
                return [
                  {
                    name: "Add",
                    route: `../add-plan`,
                  },
                ];
              }
              return [];
            }}
            tableConfig={(item) => ({
              downloadActionConfig: {
                isVisible: () => {
                  return (item?.defaultName ===
                    FormatConstants.MAMOFPRODUCT.INPROCESS_INSPECTION_PLAN ||
                    item?.defaultName ===
                    FormatConstants.MAMOFPRODUCT.FINAL_INSPECTION_PLAN) ? false : true;
                },
              },
              chip: {
                status: (data) => {
                  let color =
                    data?.row?.status === "Open"
                      ? "success"
                      : data?.row?.status === "Close"
                        ? "error"
                        : "warning";
                  return {
                    label: data?.row?.status,
                    color: color,
                  };
                },
              },
            })}
          />
        ),
      },
      // Product Plan
      {
        path: "product-plan/:productId",
        element: <ProductPlan />,
      },
      // Sampling Plan
      {
        path: "sampling-plan/manage/:id",
        element: <SamplingManage />,
      },
      {
        path: "add-plan",
        element: <AddPlan />,
      },
      // Inprocess Form
      {
        path: "inprocess-form/:id",
        element: <InProcessPlanForm />,
      },
      // Final Form
      {
        path: "final-process-form/:id",
        element: <FinalInspectionForm />,
      },
      // Plan for Sterility Assessment
      {
        path: "plan-for-sterility-assessment",
        element: <PlanForSterilityAssessment />,
      },
      // Biological Report
      {
        path: "biological-indicator-test-report/:id",
        element: <BiologicalIndicatorTestReport />,
      },
      // Chemical Report
      {
        path: "chemical-indicator-test-report/:id",
        element: <ChemicalIndicatorTestReport />,
      },
      // Sterility Report
      {
        path: "sterility-test-report/:id",
        element: <SterilityTestReport />,
      },
    ],
  },
];

export default MAMRoutes;
